export const PTKP_MAP = new Map([
    [1, 54000000],
    [2, 58500000],
    [3, 63000000],
    [4, 67500000],
    [5, 72000000],
])

export const COMMON_CONSTANT = Object.freeze({
    TAX_LAYER_1_PERCENTAGE: 0.05,
    TAX_LAYER_1_THRESHOLD: 60*1000000,
    TAX_LAYER_1_TAX_VALUE: 3*1000000,
    TAX_LAYER_2_PERCENTAGE: 0.15,
    TAX_LAYER_2_THRESHOLD: 250*1000000,
    TAX_LAYER_2_TAX_VALUE: 31.5*1000000,
    TAX_LAYER_3_PERCENTAGE: 0.25,
    TAX_LAYER_3_THRESHOLD: 500*1000000,
    TAX_LAYER_3_TAX_VALUE: 94*1000000,
    TAX_LAYER_4_PERCENTAGE: 0.30,
    TAX_LAYER_4_THRESHOLD: 5000*1000000,
    TAX_LAYER_4_TAX_VALUE: 1444*1000000,
    TAX_LAYER_5_PERCENTAGE: 0.35,
    BPJS_MULTIPLIER: 4/100,
    BPJS_GROSS_UP_MULTIPLIER: 4.28282828282828/100,
    NON_NPWP: 20,
    TAX_GROSS_UP_LAYER_1_THRESHOLD: 57*1000000,
    TAX_GROSS_UP_LAYER_2_THRESHOLD: 218.5*1000000,
    TAX_GROSS_UP_LAYER_3_THRESHOLD: 406*1000000,
    TAX_GROSS_UP_LAYER_4_THRESHOLD: 3556*1000000,
    TITLE_ALLOWANCE_PERCENTAGE: 0.05,
    TITLE_ALLOWANCE_THRESHOLD: 0.5*1000000,
    TITLE_ALLOWANCE_GROSS_UP_PERCENTAGE: 5.0505050505050/100,
})

export const ACCOUNTINGJS_CONSTANTS = Object.freeze({
    symbol: 'IDR',        
    format: '%s%v',
    decimal: '.',
    thousand: ',',
    precision: 0,
    stripZeros: false,  
    fallback: 0         
})